import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';

const INK = '#9A9A9A';

export default function Sessions() {
  const api = useApi();
  const [list, setList] = useState([]);
  const [f, setF] = useState({ label: '', dj_name: '', youtube_url: '', session_date: '' });
  const [channel, setChannel] = useState('');
  const [savedCh, setSavedCh] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = () => api.get('/api/sessions').then(setList).catch(() => {});
  useEffect(() => {
    load();
    api.get('/api/org').then(o => setChannel(o.youtube_channel_url || '')).catch(() => {});
  }, []); // eslint-disable-line

  async function add() {
    if (!f.dj_name.trim() || !f.youtube_url.trim()) { alert('DJ y link de YouTube requeridos'); return; }
    try { await api.post('/api/sessions', f); setF({ label: '', dj_name: '', youtube_url: '', session_date: '' }); load(); }
    catch (e) { alert(e.message); }
  }
  async function rm(id) { try { await api.del(`/api/sessions/${id}`); load(); } catch (e) { alert(e.message); } }
  async function saveChannel() {
    try { await api.patch('/api/org', { youtube_channel_url: channel }); setSavedCh(true); setTimeout(() => setSavedCh(false), 2000); }
    catch (e) { alert(e.message); }
  }

  return (
    <div className="lb-fade">
      <div className="lb-display" style={{ fontSize: 24, marginBottom: 18 }}>Canal de Youtube</div>

      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 18, display: 'flex', gap: 10, alignItems: 'end', flexWrap: 'wrap' }}>
        <Field label="URL del canal de YouTube"><input className="lb-input" style={{ minWidth: 320 }} value={channel} onChange={e => setChannel(e.target.value)} placeholder="https://youtube.com/@tucanal" /></Field>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={saveChannel}>Guardar canal</button>
        {savedCh && <span style={{ color: '#2ecc71', fontSize: 12 }}>Guardado ✓</span>}
      </div>

      <div className="lb-card" style={{ padding: '18px 20px', marginBottom: 22, display: 'flex', gap: 10, alignItems: 'end', flexWrap: 'wrap' }}>
        <Field label="Línea 1 (sesión / número)"><input className="lb-input" value={f.label} onChange={e => setF({ ...f, label: e.target.value })} placeholder="Ej: SESSION #03" /></Field>
        <Field label="Línea 2 (DJs)"><input className="lb-input" value={f.dj_name} onChange={e => setF({ ...f, dj_name: e.target.value })} placeholder="Giuli Pozzetto B2B Tomy Capde" /></Field>
        <Field label="Link de YouTube"><input className="lb-input" style={{ minWidth: 280 }} value={f.youtube_url} onChange={e => setF({ ...f, youtube_url: e.target.value })} placeholder="https://youtube.com/watch?v=…" /></Field>
        <Field label="Fecha (no se muestra, ordena)"><input className="lb-input" type="date" value={f.session_date} onChange={e => setF({ ...f, session_date: e.target.value })} /></Field>
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={add}>+ Agregar session</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px,1fr))', gap: 16 }}>
        {list.map(s => (
          <div key={s.id} className="lb-card" style={{ overflow: 'hidden' }}>
            <div style={{ aspectRatio: '16/9', background: s.thumbnail_url ? `center/cover no-repeat url(${s.thumbnail_url})` : 'var(--ink-200)' }} />
            <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: 'var(--ink-600)', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase' }}>{s.label || `Session #${s.session_number}`}</div>
                <div style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{s.dj_name}</div>
                <a href={s.youtube_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: 'var(--red-400)' }}>Ver en YouTube ↗</a>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setEditing(s)}>Editar</button>
                <button className="lb-iconbtn" onClick={() => rm(s.id)}>✕</button>
              </div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div style={{ color: INK, fontSize: 13 }}>Sin sessions todavía.</div>}
      </div>

      {editing && <EditModal api={api} session={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}

function EditModal({ api, session, onClose, onSaved }) {
  const [f, setF] = useState({
    label: session.label || '',
    dj_name: session.dj_name || '',
    youtube_url: session.youtube_url || '',
    session_date: session.session_date ? String(session.session_date).slice(0, 10) : '',
  });
  const [saving, setSaving] = useState(false);
  async function save() {
    if (!f.dj_name.trim() || !f.youtube_url.trim()) { alert('DJ y link de YouTube requeridos'); return; }
    setSaving(true);
    try { await api.patch(`/api/sessions/${session.id}`, f); onSaved(); }
    catch (e) { alert(e.message); } finally { setSaving(false); }
  }
  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal" onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 28px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div className="lb-eyebrow">Editar session</div>
            <div className="lb-h" style={{ fontSize: 20, marginTop: 4 }}>{f.dj_name || 'Sin DJ'}</div>
          </div>
          <button className="lb-iconbtn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Field label="Línea 1 (sesión / número)"><input className="lb-input" value={f.label} onChange={e => setF({ ...f, label: e.target.value })} placeholder="Ej: SESSION #03" /></Field>
          <Field label="Línea 2 (DJs)"><input className="lb-input" value={f.dj_name} onChange={e => setF({ ...f, dj_name: e.target.value })} /></Field>
          <Field label="Link de YouTube"><input className="lb-input" value={f.youtube_url} onChange={e => setF({ ...f, youtube_url: e.target.value })} /></Field>
          <Field label="Fecha (ordena, no se muestra)"><input className="lb-input" type="date" value={f.session_date} onChange={e => setF({ ...f, session_date: e.target.value })} /></Field>
        </div>
        <div style={{ padding: '18px 28px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={onClose}>Cancelar</button>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={saving}>{saving ? 'Guardando…' : 'Guardar cambios'}</button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) { return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>; }
